<template>
  <div class="md-layout text-center" style="margin-left: auto;margin-right: auto;height: 60vh;min-height: 530px; z-index: 100; width: 66vw;min-width: 1000px;">
    <notifications></notifications>
    <div class="
      md-layout-item
      md-size-100
      md-medium-size-100
      md-small-size-100
      md-xsmall-size-100
    ">
      <md-card style="width: 100%;height: 100%;background: #FFF;">
        <md-card-content>
          <div class="forgetpw">
            <!-- 1 -->
            <div class="step-box" :class="{'selected-step': step === 1}">
              <div class="step-num">1</div>
              <div class="step-info">
                Verification of identity
              </div>
            </div>
            <div class="line-box">
              <div class="line"></div>
            </div>
            <!-- 2 -->
            <div class="step-box" :class="{'selected-step': step === 2}">
              <div class="step-num">2</div>
              <div class="step-info">
                Setting a new password
              </div>
            </div>
            <div class="line-box">
              <div class="line"></div>
            </div>
            <!-- 3 -->
            <div class="step-box" :class="{'selected-step': step === 3}">
              <div class="step-num">3</div>
              <div class="step-info">
                Fulfillment
              </div>
            </div>
          </div>
          <!-- 1 -->
          <div class="input-box" v-show="step === 1">
            <div>
              <md-field class='line-input' style="padding-left: 8px !important;">
                <md-select v-model="zone">
                  <md-option v-for="item in countryArray" :key="item.code" :value="item.code">{{
                    $router.history.current.query.lang === "zh-CN" ?item.cn_name :item.name
                  }}</md-option>
                </md-select>
                <div id="zones" @click="$refs.zone.open()" style="position:absolute; top: 0; bottom: 0;left: 0; right: 0;z-index: 1;cursor: pointer;"/>
              </md-field>
            </div>

            <div style="display: flex;position: relative;">
              <md-field class='line-input' style="width: 15%;min-width: 90px;padding-left: 8px !important;" v-if="type === 1">
                <md-select v-model="phone_fount">
                  <md-option :value="'+86'">+86</md-option>
                </md-select>
              </md-field>
              <md-field class="line-input">
                <md-input v-model="user" :placeholder='type === 1 ?$I18n("pls_input_phone") :$I18n("pls_input_email")'></md-input>
              </md-field>
              <div v-if="zone == 'CN'" class="change-login-type">
              <!-- <div class="change-login-type"> -->
                <!-- 手机 -->
                <img v-show="type === 1" @click="type = 2" src="/img/haiqora/Frame_2.png" height="18" width="18">
                <!-- 邮箱 -->
                <img v-show="type === 2" @click="type = 1" src="/img/haiqora/Frame_1.png" height="18" width="18" class="email">
              </div>
            </div>

            <div>
              <div style="display: flex;justify-content: space-between;">
                <md-field class='line-input big-placeholder'>
                  <md-input v-model="input_vcode" :placeholder='$I18n("pls_input_vc_code")'></md-input>
                </md-field>
                <button class='simple-btn' style="width: 35%;" @click="api_getVcCode">
                  {{countDown > 0 ?(countDown + "s") :$I18n("click_get")}}
                </button>
              </div>
            </div>

            <button class="diy-next" @click="submit">
              {{$I18n("next_step")}}
            </button>
          </div>
          <!-- 2 -->
          <div class="input-box" v-show="step === 2">
            <div style="display: flex;justify-content: space-between;">
              <md-field class='line-input big-placeholder'>
                <md-input v-model="password" :placeholder="$I18n('pls_input_password')" type="password"></md-input>
              </md-field>
            </div>
            <p class="pw_info">{{$I18n("pls_input_password_2")}}</p>
            <div style="display: flex;justify-content: space-between;">
              <md-field class='line-input big-placeholder'>
                <md-input v-model="password_c" :placeholder="$I18n('pls_input_confirm_password')" type="password"></md-input>
              </md-field>
            </div>
            <button class="diy-next" @click="submit">
              {{$I18n("next_step")}}
            </button>
          </div>
          <!-- 3 -->
          <div class="input-box" v-show="step === 3">
            <div>
              <img src="/img/haiqora/pw_succ.png" class="pw_succ" />
            </div>
            <p class="change_succ_pw">{{$I18n("change_succ_pw")}}</p>
          </div>
        </md-card-content>
      </md-card>
    </div>
    <zone-select-modal ref="zone" @select="new_zone => (zone = new_zone)"/>
  </div>
</template>
<script>

// import verification from 'verification-code';
import {countryArray}  from "@/common/continent.js";
import ZoneSelectModal from "@/components/Common/ZoneSelectModal";
import {passwordLegal, emailLegal}   from "@/common/tools.js";
/*continentArray*/
export default {
  components: {
    ZoneSelectModal,
  },
  created(){
    console.log(localStorage._zone)
    if(!localStorage._zone){
      if(navigator.language === "zh-CN"){
        localStorage._zone = "CN";
        this.zone = "CN";
      } else {
        localStorage._zone = "US";
        this.zone = "US";
      }
    }

    this.$root.state.apiurl = "";
    if(localStorage._zone !== "CN"){
      this.type = 2;
    }
    // if(localStorage._zone && localStorage._zone !== "CN"){
    //   this.type = 2;
    // }
  },
  data() {
    return {
      step : 1,
      type : 1,    // 手机(1)/邮箱(2)登录
      countDown:0, // 获取验证码冷却
      input_vcode: "",
      user: "", // 手机|邮箱
      phone_fount: "+86", // 手机号区

      password   : "",
      password_c : "",

      countryArray: countryArray,
      zone: localStorage._zone?localStorage._zone :"",
    };
  },
  watch:{
    zone(val){
      console.log(val)
      localStorage._zone = val;
      if(val !== "CN"){
        this.type = 2;
      }
    },
    type(){
      this.user = "";
      // 重置验证码
      this.input_vcode = "";
      this.countDown = 0;
    },
  },
  methods: {
    submit(){
      if(this.step === 1){
        if(!this.input_vcode){
          this.$errorMsg(this.$I18n("pls_input_vc_code"), 3000);
          return
        }
        this.$api.g_Otp({
          link_param : this.phone_fount.replace("+",""),
          notify_type: 6,
          app_key    : window.appConfig.custom_flag,
          push_type  : 2,
          link_id    : this.user,
          ver_code   : this.input_vcode,
        })
          .then(res => {
            if(res.code == 514){
              this.$errorMsg(this.$I18n("error_code_514_3"), 3000);
            } else {
              this.step = 2;
            }
          })
          .catch(() => {
            this.$errorMsg(this.$I18n("unknown_error"), 3000);
          })
        
      } else if(this.step === 2){
        this.api_changePw();
      }
    },
    // 修改密码
    api_changePw(){
      // 密码不合法
      if(!passwordLegal(this.password)){
        this.$errorMsg(this.$I18n("pw_inval"), 3000);
        return
      }
      if(this.password !== this.password_c){
        this.$errorMsg(this.$I18n("password_no_equal"), 3000);
        return
      }
      const isHttps = window.location.protocol === "https:";
      this.$api.__sendNumApi(100, window.appConfig.umeye_api(isHttps, window.appConfig.umeye_url), {
        client_id  : "web",
        client_type: 6,
        custom_flag: window.appConfig.custom_flag,
        zone : this.zone,
        user_id    : this.type === 1 ?this.phone_fount.replace("+","")+this.user :this.user,
      })
        // 请求 202
        .then(res => {
          if(res.h.e !== 200){
            throw res
          }
          return this.$api.__sendNumApi(210,window.appConfig.umeye_api(isHttps, res.b.umh_host), {
            client_id  : "web",
            client_type: 6,
            enc_type   : 2,
            custom_flag: window.appConfig.custom_flag,
            user_id   : this.type === 1 ?this.phone_fount.replace("+","")+this.user :this.user,
            ver_type  : this.type,
            ver_code  : this.input_vcode,
            new_passwd: this.password,
            old_passwd: "",
          })
        })
        // 处理回调
        .then(res => {
          if(res.h.e !== 200){
            throw res
          }
          this.step = 3;
          setTimeout(() => {
            this.$gopage('/login')
          }, 3000)
        })
        .catch(res => {
          console.error(res)
          if(res && res.h){
            if(res.h.e == 1032){
              this.$errorMsg(this.$I18n("error_code_1032"), 3000)
            } else if(res.h.e == 1030){
              this.$errorMsg(this.$I18n("error_code_1030"), 3000)
            } else if(res.h.e == 514){
              this.$errorMsg(this.$I18n("error_code_514_2"), 3000)
            } else {
              this.$errorMsg(this.$I18n("edit_fail"), 3000)
            }
          } else {
            this.$errorMsg(this.$I18n("edit_fail"), 3000)
          }
          this.step = 1;
          this.input_vcode="";
          this.password   ="";
          this.password_c ="";
        })
    },
    // 获取后台验证码
    api_getVcCode(){
      if(this.countDown > 0){
        return
      }
      if(this.type === 2 && !emailLegal(this.user)){
        this.$errorMsg(this.$I18n("pls_input_email"), 3000)
        return
      }
      if(this.type === 1 && isNaN(this.user)){
        this.$errorMsg(this.$I18n("pls_input_phone"), 3000)
        return
      }
      this.$api.g_VCode({
        link_param  : this.phone_fount.replace("+",""),
        msg_param   : "",
        app_key     : window.appConfig.custom_flag,
        link_id     : this.user,
        notify_type : 6,
        push_type   : this.type === 1 ?3 :2, // 2: 邮件，3: 短信
      })
      .then(this.$Then(() => {
        this.countDown = 120;
        let cd = setInterval(() => {
          if(this.countDown === 1){
            clearInterval(cd);
          }
          this.countDown = this.countDown - 1;
        } , 1000)
        this.$successMsg(this.$I18n("vc_sended"));
      }))
      .catch(this.$Catch(this.$I18n("get_error")));
    },
  },
};
</script>

<style scoped>
  .change_succ_pw{
    color: #33C400;
    font-size: 32px;
    font-weight: 400;
    text-align: center;
    margin-top: 26px;
    margin-left: -50%;
    margin-right: -50%;
  }
  .pw_succ{
    width: 200px;
    height: 200px;
    margin: -16px auto 0;
  }
  .pw_info{
    font-size: 10px;
    text-align: left;
    margin: 0;
    margin-left: 10px;
    margin-top: -6px;
    color: #888;
    line-height: 12px;
  }
  .simple-btn{
    border:0;
    background: none;
    height: 47px;
    line-height: 47px;
    margin-top: 16px;
    border-bottom: 1px solid #d2d2d2;
    color: #578EFF;
    font-size: 16px;
    font-weight: 400;
  }
  .diy-next{
    width: 100%;
    line-height: 69px;
    height: 69px;
    background: #578EFF;
    color: #FFFFFF;
    font-family: Microsoft YaHei;
    text-align: center;
    font-size: 30px;
    font-weight: 400;
    border: none;
    border-radius: 9px;
    margin-top: 50px;
  }
  .input-box{
    width: 45%;
    margin: 86px auto 0;
  }
  .forgetpw{
    display: flex;
    margin-top: 20px;
  }
  .step-box{
    width: 24%;
    flex: 2;
    line-height: 26px;
    color: #7F7F7F;
  }
  .line-box{
    width: 14%;
    flex: 1;
    box-sizing: border-box;
    padding: 0 15px;
  }
  .step-num{
    margin: 24px auto;
    height: 51px;
    width: 51px;
    line-height: 51px;
    font-size: 40px;
    font-weight: 400;
    border-radius: 50%;
    box-sizing: border-box;
    border: 2px solid #7F7F7F;
  }
  .step-info{
    font-size: 20px;
    font-weight: 400;
  }
  .selected-step .step-num{
    border-color: #578EFF;
    color: #578EFF;
  }
  .selected-step .step-info{
    color: #578EFF;
  }
  .line-box{
    padding-top: 99px;
  }
  .line{
    margin: 12.5px 0;
    background: #7F7F7F;
    height: 1px;
    width: 100%;
  }
  .change-login-type{
    position: absolute;
    right: 7px;
    top: 24px;
    height: 33px;
    width: 33px;
    border-radius: 50%;
    background: rgb(229,229,229);
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
  }
  .change-login-type img{
    width: 20px;
    height: 20px;
  }
</style>